(function () {
  // Father's Day 2026 — clone of bundle-multi-add-v2.js
  // Changes from v2:
  //   - FREE_GIFT_THRESHOLD_CENTS: $100 -> $150
  //   - GATE_HANDLE: keyed to fathers-day product
  //   - LAUNCH_TS / END_TS: pre-launch + post-offer lock
  //   - BONUS_CODES: none (2-day event, no % bundle codes)
  //   - No discount cookie / no sessionStorage bonus code
  //   - ensureFreeAscend fires at $150 threshold
  //   - Checkout: standard (no discount redirect needed since no code discount)

  var ASCEND_VARIANT_ID = 50787318399291; // Black Ascend - default free gift
  // Both Black + White are the SAME free gift (color choice). Treat EITHER as "Ascend present"
  // so we never force-add a second Ascend (which would be charged: discount frees only 1/order).
  var ASCEND_VARIANT_IDS = [50787318399291, 50787318432059];
  function isAscend(vid) { return ASCEND_VARIANT_IDS.indexOf(vid) !== -1; }
  var FREE_GIFT_THRESHOLD_CENTS = 15000;  // $150 to trigger free Ascend
  var GATE_HANDLE = 'fathers-day-sale';
  var LAUNCH_TS   = 1781928000; // 2026-06-20T04:00:00Z (= 2026-06-20 00:00 EDT)
  var END_TS      = 1782100799; // 2026-06-22T03:59:59Z (= 2026-06-21 23:59:59 EDT)
  var DEBUG = (typeof window !== 'undefined') && /[?&]fddebug=1/.test(window.location.search);

  // Only run on the FD landing page
  if (typeof window !== 'undefined' && window.__fdBundleInit) return;
  if (typeof window !== 'undefined') window.__fdBundleInit = true;

  function nowTs() { return Math.floor(Date.now() / 1000); }
  function isOnFDPage() {
    return typeof window !== 'undefined' &&
           (window.location.pathname.indexOf(GATE_HANDLE) !== -1 ||
            (document.documentElement.dataset.productHandle === GATE_HANDLE));
  }

  function debugToast(line) {
    if (!DEBUG) return;
    var box = document.getElementById('fd-bundle-debug-toast');
    if (!box) {
      box = document.createElement('div');
      box.id = 'fd-bundle-debug-toast';
      box.style.cssText = 'position:fixed;left:8px;right:8px;bottom:8px;z-index:99999;background:rgba(20,20,20,.95);color:#9ef;font:12px/1.4 ui-monospace,monospace;padding:10px;border-radius:6px;max-height:50vh;overflow:auto;white-space:pre-wrap;box-shadow:0 8px 24px rgba(0,0,0,.4);';
      document.body.appendChild(box);
    }
    var stamp = (new Date()).toISOString().slice(11, 19);
    box.textContent += '[' + stamp + '] ' + line + '\n';
    box.scrollTop = box.scrollHeight;
  }

  // Shopify BxGy does NOT auto-add the gift. We push Ascend to cart
  // when subtotal >= $150, then BxGy makes it $0.
  function ensureFreeAscend() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Exclude Ascend from $150 threshold: BxGy counts only eligible items, Ascend is the gift not a purchase
        var eligibleSubtotal = (cart.items || []).reduce(function (sum, i) {
          return isAscend(i.variant_id) ? sum : sum + (i.line_price || i.original_line_price || 0);
        }, 0);
        debugToast('ensureFreeAscend: eligibleSubtotal=' + eligibleSubtotal + ' threshold=' + FREE_GIFT_THRESHOLD_CENTS);
        if (eligibleSubtotal < FREE_GIFT_THRESHOLD_CENTS) return cart;
        var hasAscend = (cart.items || []).some(function (i) { return isAscend(i.variant_id); });
        if (hasAscend) { debugToast('Ascend already in cart'); return cart; }
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: ASCEND_VARIANT_ID, quantity: 1 }] })
        }).then(function (r) {
          debugToast('Ascend add: ' + r.status);
          return r.ok ? r.json() : cart;
        });
      })
      .catch(function () { return null; });
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (txt) {
          var msg = 'Cart add failed';
          try { var j = JSON.parse(txt); msg = j.description || j.message || msg; } catch (e) {}
          var err = new Error(msg);
          err.status = r.status;
          throw err;
        });
      }
      return r.json();
    });
  }

  function refreshCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    return new Promise(function (resolve) { setTimeout(resolve, 700); });
  }

  function updateHeaderBadge() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-link__bubble-num, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        var bubble = document.querySelector('.cart-link__bubble');
        if (bubble) bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
        return cart;
      })
      .catch(function () { return null; });
  }

  function openDrawer() {
    if (!window.__cartDrawerInstance && window.theme && typeof window.theme.Drawers === 'function') {
      try { window.__cartDrawerInstance = new window.theme.Drawers('CartDrawer', 'cart'); }
      catch (e) { window.__cartDrawerInstance = null; }
    }
    var inst = window.__cartDrawerInstance;
    if (inst && typeof inst.open === 'function') {
      if (!inst.isOpen) inst.open();
      return true;
    }
    var toggle = document.querySelector('.js-drawer-open-cart');
    if (toggle) {
      var evt = new MouseEvent('click', { bubbles: true, cancelable: true });
      var ok = toggle.dispatchEvent(evt);
      if (ok && evt.defaultPrevented) return true;
    }
    return false;
  }

  function dedupItemsAgainstCart(items) {
    // MULTI-GIFT (2026-06-17): each bundle brings its own free Ascend. The BxGy now frees 1 Ascend
    // per $150 of eligible spend (usesPerOrderLimit unlimited), so a customer who adds 2-3 bundles
    // gets 2-3 free Ascend. We therefore DO NOT cap Ascend here; every bundle add carries its gift.
    // (ensureFreeAscend below stays as a safety net for a >=$150 cart that somehow has zero Ascend.)
    return Promise.resolve(items);
  }

  function safe(p) { return Promise.resolve(p).catch(function () { return null; }); }

  function ensureDrawerBannerStyles() {
    if (document.getElementById('fd-cart-drawer-bonus-styles')) return;
    var s = document.createElement('style');
    s.id = 'fd-cart-drawer-bonus-styles';
    s.textContent =
      '.fd-cart-ascend-notice{margin:0 0 14px;padding:13px 15px;border-radius:6px;' +
      'background:linear-gradient(135deg,#1F1B16,#2A2620);color:#F4EFE8;' +
      'font-family:Georgia,serif;border-left:3px solid #B88A2E;}' +
      '.fd-cart-ascend-notice__title{font-family:"Cormorant Garamond",Georgia,serif;font-size:1.1rem;font-weight:600;letter-spacing:.02em;margin-bottom:7px;}' +
      '.fd-cart-ascend-notice__line{font-size:.8rem;opacity:.94;display:flex;justify-content:space-between;gap:12px;margin:3px 0;}' +
      '.fd-cart-ascend-notice__line b{color:#E6C88A;font-weight:600;white-space:nowrap;}' +
      '.fd-cart-ascend-notice__total{font-size:.84rem;margin-top:8px;padding-top:7px;border-top:1px solid rgba(244,239,232,.18);display:flex;justify-content:space-between;gap:12px;font-weight:600;}' +
      '.fd-cart-ascend-notice__total b{color:#E6C88A;white-space:nowrap;}' +
      /* FIX: cart drawer crop on short mobile viewports (Messenger in-app browser ~390x640).
         Root cause: .drawer__inner and .drawer__scrollable both use flex:1 1 auto without
         min-height:0, so they cannot shrink below their content size inside the flex column.
         This CSS is scoped to #CartDrawer and only injected when the FD BYO section is on page
         (this file loads via fd-byo.liquid which is FD-template-only). Safe: no impact on
         .drawer__footer position or desktop layout. */
      '#CartDrawer .drawer__inner{min-height:0;}' +
      '#CartDrawer .drawer__scrollable{min-height:0;}' +
      /* Hide BYO sticky mbar when cart drawer is open (stacking two bottom bars) */
      'body.js-drawer-open [data-fdbyo-mbar]{display:none!important;}';
    document.head.appendChild(s);
  }

  function fmtMoney(cents) { return '$' + (Math.round(cents) / 100).toFixed(2); }

  // Hide line-level discount LABELS that resolve to a $0 allocation (e.g. AeroCherub showing
  // "Free Ascend gift (-$0.00)" because it is the BxGy 'buy' line). That $0 label is meaningless
  // noise and confused customers ("why does this item have a red discount but the other doesn't?").
  function hideZeroDiscountLabels(drawer) {
    if (!drawer) return;
    drawer.querySelectorAll('.cart__discount').forEach(function (d) {
      if (/\(-\s*\$0(\.0+)?\)/.test(d.textContent || '')) d.style.display = 'none';
    });
  }

  // Cart drawer summary: shows exactly WHICH savings applied + the amounts, so the customer
  // understands the bundle % and the free gift instead of guessing from inconsistent line labels.
  function injectAscendBanner() {
    ensureDrawerBannerStyles();
    var attempts = 0;
    function tryInject() {
      attempts++;
      var drawer = document.querySelector('#CartDrawer');
      var anchor = drawer && (
        drawer.querySelector('.drawer__scrollable') ||
        drawer.querySelector('[data-products]') ||
        drawer.querySelector('.drawer__inner')
      );
      if (!anchor) {
        if (attempts < 6) return setTimeout(tryInject, 250);
        return;
      }
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          hideZeroDiscountLabels(drawer);
          var eligibleSubtotal = (cart.items || []).reduce(function (sum, i) {
            return isAscend(i.variant_id) ? sum : sum + (i.line_price || i.original_line_price || 0);
          }, 0);
          drawer.querySelectorAll('.fd-cart-ascend-notice').forEach(function (n) { n.remove(); });
          if (eligibleSubtotal < FREE_GIFT_THRESHOLD_CENTS) return;

          // free-Ascend savings + count
          var ascSaved = 0, ascQty = 0;
          (cart.items || []).forEach(function (i) {
            if (!isAscend(i.variant_id)) return;
            ascSaved += (i.original_line_price || 0) - (i.final_line_price || 0);
            ascQty += i.quantity || 0;
          });
          // order-level bundle % discounts (15% / 20%)
          var rows = '';
          (cart.cart_level_discount_applications || []).forEach(function (d) {
            var amt = d.total_allocated_amount || 0;
            if (amt <= 0) return;
            rows += '<div class="fd-cart-ascend-notice__line"><span>' + d.title + '</span><b>-' + fmtMoney(amt) + '</b></div>';
          });
          if (ascQty > 0) {
            rows += '<div class="fd-cart-ascend-notice__line"><span>Free Ascend gift' + (ascQty > 1 ? ' &times;' + ascQty : '') +
                    '</span><b>-' + fmtMoney(ascSaved) + '</b></div>';
          }

          var el = document.createElement('div');
          el.className = 'fd-cart-ascend-notice';
          el.innerHTML =
            '<div class="fd-cart-ascend-notice__title">Your Father\'s Day savings</div>' +
            rows +
            '<div class="fd-cart-ascend-notice__total"><span>You save</span><b>' + fmtMoney(cart.total_discount || 0) + '</b></div>';
          if (anchor.firstChild) anchor.insertBefore(el, anchor.firstChild);
          else anchor.appendChild(el);
        }).catch(function () {});
    }
    tryInject();
  }
  window.injectFDAscendBanner = injectAscendBanner;

  // Serialize bundle adds: rapid clicks on 2-3 bundles queue one-after-another instead of
  // running 3 overlapping flows (which fired 3x cart:build + up to 9 banner re-injections and
  // made the cart drawer jank / "not load in time"). One refresh + one debounced banner per settle.
  var fdAddChain = Promise.resolve();
  var fdBannerTimer = null;
  function scheduleBanner() {
    if (fdBannerTimer) clearTimeout(fdBannerTimer);
    fdBannerTimer = setTimeout(injectAscendBanner, 650);
  }

  window.__fdBundleAddAndOpenDrawer = function (items, btn, originalLabel, opts) {
    opts = opts || {};
    btn.disabled = true;
    btn.textContent = 'Adding...';
    debugToast('fd-start: items=' + items.length);

    fdAddChain = fdAddChain.then(function () {
      return dedupItemsAgainstCart(items)
        .then(function (filtered) {
          debugToast('fd-dedup -> ' + (filtered ? filtered.length : 0));
          if (!filtered || !filtered.length) return Promise.resolve();
          return addToCart(filtered);
        })
        .then(function () { return ensureFreeAscend(); })
        .then(function () { return safe(updateHeaderBadge()); })
        .then(function () {
          btn.disabled = false;
          btn.textContent = originalLabel;
          if (opts.checkoutCode) {
            window.location.href = '/discount/' + opts.checkoutCode + '?redirect=/checkout';
            return;
          }
          return safe(refreshCartDrawer()).then(function () {
            var opened = openDrawer();
            debugToast('fd-drawer.open: ' + opened);
            scheduleBanner(); // single debounced banner inject (was 3x setTimeout per add)
            if (!opened) {
              btn.textContent = 'Added. View cart >';
              btn.onclick = function () { window.location.href = '/cart'; };
            }
          });
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = 'Could not add: ' + (err.message || 'try again');
          setTimeout(function () { btn.textContent = originalLabel; }, 4000);
        });
    });
    return fdAddChain;
  };
})();

(function () {
  // Re-inject ascend banner after drawer rebuild
  document.addEventListener('cart:build', function () {
    setTimeout(function () {
      if (window.injectFDAscendBanner) window.injectFDAscendBanner();
    }, 500);
  });
})();

(function () {
  // Bind [data-fd-bundle-add] buttons
  function bind(btn) {
    if (btn.dataset.fdBundleBound === '1') return;
    btn.dataset.fdBundleBound = '1';
    btn.addEventListener('click', function () {
      var csv = btn.dataset.bundleVariants || '';
      var ids = csv.split(',').map(function (s) { return parseInt(s.trim(), 10); }).filter(Boolean);
      if (!ids.length) return;
      var items = ids.map(function (id) { return { id: id, quantity: 1 }; });
      var original = btn.textContent;
      var code = btn.dataset.checkoutCode || '';
      var opts = code ? { checkoutCode: code } : {};
      window.__fdBundleAddAndOpenDrawer(items, btn, original, opts);
    });
  }
  function init() {
    document.querySelectorAll('[data-fd-bundle-add]').forEach(bind);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  // Variant picker for FD bundle sections (identical logic to v2, namespaced)
  function moneyFmt(cents) { return '$' + (cents / 100).toFixed(2); }
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function setupBundleVariantPickers() {
    document.querySelectorAll('section.fd-bundle-pair, .fd-bundle-pair').forEach(function (section) {
      if (section.dataset.fdBpVariantInit === '1') return;
      section.dataset.fdBpVariantInit = '1';
      // fd-bundle-pair renders variant <select> SERVER-SIDE (data-bundle-variant-select) and has its own
      // inline change handler; skip the JS picker here to avoid injecting a DUPLICATE select.
      if (section.querySelector('[data-bundle-variant-select]')) return;
      var cta = section.querySelector('[data-fd-bundle-add]');
      if (!cta) return;
      var origIds = (cta.dataset.bundleVariants || '').split(',').filter(Boolean);
      var items = section.querySelectorAll('.bundle-pair__item:not(.bundle-pair__item--free)');
      var freeGiftId = null;
      var freeItem = section.querySelector('.bundle-pair__item--free');
      if (freeItem && origIds.length > items.length) {
        freeGiftId = origIds[origIds.length - 1];
      }
      var slotState = [];
      items.forEach(function (el, idx) {
        var handle = el.dataset.productHandle;
        if (!handle) return;
        var imgEl = el.querySelector('img');
        var priceEl = el.querySelector('.bundle-pair__item-price');
        var variantEl = el.querySelector('.bundle-pair__item-variant');
        var currentVid = origIds[idx] || null;
        slotState.push({ el: el, handle: handle, idx: idx, currentVid: currentVid,
                         priceEl: priceEl, imgEl: imgEl, variantEl: variantEl });
      });
      function rebuildCTA() {
        var ids = slotState.map(function (s) { return s.currentVid; }).filter(Boolean);
        if (freeGiftId) ids.push(freeGiftId);
        cta.dataset.bundleVariants = ids.join(',');
      }
      Promise.all(slotState.map(function (s) { return fetchProduct(s.handle); }))
        .then(function (products) {
          products.forEach(function (prod, idx) {
            if (!prod) return;
            var s = slotState[idx];
            var avail = prod.variants.filter(function (v) { return v.available; });
            var current = prod.variants.find(function (v) { return String(v.id) === String(s.currentVid); }) || avail[0];
            if (!current) return;
            s.currentVid = String(current.id);
            s.currentPrice = current.price;
            if (avail.length <= 1) { rebuildCTA(); return; }
            var sel = document.createElement('select');
            sel.className = 'bundle-pair__item-variant-select';
            sel.setAttribute('aria-label', 'Choose variant for ' + prod.title);
            avail.forEach(function (v) {
              var img = (v.featured_image && v.featured_image.src) || prod.featured_image || '';
              if (img && img.indexOf('?') === -1) img += '?width=360';
              var opt = document.createElement('option');
              opt.value = v.id;
              opt.dataset.price = v.price;
              opt.dataset.image = img;
              opt.textContent = v.title + ' - ' + moneyFmt(v.price);
              if (String(v.id) === s.currentVid) opt.selected = true;
              sel.appendChild(opt);
            });
            if (s.variantEl) { s.variantEl.replaceWith(sel); }
            else if (s.priceEl) { s.priceEl.parentNode.insertBefore(sel, s.priceEl); }
            else { s.el.appendChild(sel); }
            sel.addEventListener('click', function (e) { e.stopPropagation(); });
            sel.addEventListener('change', function () {
              var opt = sel.options[sel.selectedIndex];
              s.currentVid = opt.value;
              s.currentPrice = parseInt(opt.dataset.price) || 0;
              if (s.priceEl) s.priceEl.textContent = moneyFmt(s.currentPrice);
              if (s.imgEl && opt.dataset.image) {
                var fresh = new Image();
                fresh.onload = function () { s.imgEl.src = opt.dataset.image; };
                fresh.src = opt.dataset.image;
              }
              rebuildCTA();
            });
          });
          rebuildCTA();
        });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupBundleVariantPickers);
  } else {
    setupBundleVariantPickers();
  }
})();
